import mainStyle from '../../mainStyle.module.scss';
import sliderStyle from './slider.module.scss';

import icn_close from 'assets/images/icons/icn_close.svg';
import img_device_ap from 'assets/images/icons/img_device_ap.svg';
import img_device_switch from 'assets/images/icons/img_device_switch.svg';
import img_device_gateway from 'assets/images/icons/img_device_gateway.svg';
import icon_snmp from "assets/images/icons/icn_Info_solid.svg";

import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from "@mui/material";

import { authStateOption, deviceTypeOption, protocolTypeOption } from "../../const";
import { getDefaultTabProp } from "../../theme";

import Overview from './Overview';
import IpSettings from './IpSettings';

const defaultTabOptions = [
  { label: 'Overview', value: 'overview' },
  { label: 'IP Settings', value: 'ipSettings' },
];

const Slider = (props) => {
  const {
    openSlider, onToggleSlider,
    auth, device,
    changeToConfigurable, startAdoptProcessForOneDevice,
    isNotSupportDNSDevice
  } = props;

  // State
  const [tabOptions, setTabOptions] = useState([]);
  const [selectedTab, setSelectedTab] = useState(defaultTabOptions[0]);

  // Method
  const closeSliderWindow = () => {
    onToggleSlider();
  };

  const handleChangeTab = (_, newValue) => {
    setSelectedTab(newValue);

    if (newValue === 'ipSettings' && device.authStatus === authStateOption.failed) {
      setTimeout(() => {
        setSelectedTab(defaultTabOptions[0].value);
      }, 0);
    }
  };

  // Side effect
  useEffect(() => {
    if (!device) {
      return;
    }

    if (device.provisioning) {
      setTabOptions(defaultTabOptions.filter((tab) => tab.value !== 'ipSettings'));
    } else {
      setTabOptions(defaultTabOptions);
    }

    setSelectedTab(defaultTabOptions[0].value);
  }, [device]);

  if (!device || tabOptions.length === 0) {
    return null;
  }

  let deviceType = null;
  for (const type in deviceTypeOption) {
    if (deviceTypeOption[type].value === device.deviceType.value) {
      deviceType = deviceTypeOption[type]
    }
  }

  return (
    <>
      <div className={`${sliderStyle["slider-info"]} ${openSlider ? sliderStyle["open"] : ""}`}>
        <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
          <Box style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", }}>
            {deviceType.value === deviceTypeOption.ap.value && (<img src={img_device_ap} alt="" />)}
            {deviceType.value === deviceTypeOption.switch.value && (<img src={img_device_switch} alt="" />)}
            {deviceType.value === deviceTypeOption.gateway.value && (<img src={img_device_gateway} alt="" />)}
            <Box className={sliderStyle["model-name-container"]}>
              <Box style={{ fontFamily: 'Inter', marginLeft: '10px', color: '#373737', fontWeight: 'bold', fontSize: '20px' }}>
                {device.modelName}
              </Box>
              <Box display="flex" alignItems="center">
                <Box className={`${mainStyle["chip-name"]} ${mainStyle[`${device.status.value}-chip`]} ${sliderStyle["chip-name"]}`}>
                  {device.status.label}
                </Box>
                {device.protocolType === protocolTypeOption.snmp && (
                  <Box display="flex" alignItems="center" style={{ marginLeft: '10px' }}>
                    <img src={icon_snmp} alt="" />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          <Box>
            <img src={icn_close} alt="" style={{ cursor: 'pointer' }} onClick={closeSliderWindow} />
          </Box>
        </Box >
        {device.protocolType === protocolTypeOption.snmp && (
          <>
            <Box className={sliderStyle["tip"]} >
              Please enable SSH on this switch before adoption.
              <span className={sliderStyle["link"]} style={{ marginLeft: '10px', }}>
                How to enable SSH?
              </span>
            </Box>
          </>
        )}
        <Box>
          <Tabs
            value={selectedTab}
            onChange={handleChangeTab}
            TabIndicatorProps={{ ...getDefaultTabProp().tabIndicatorProps }}
            sx={{ ...getDefaultTabProp().sx }}
          >
            {
              tabOptions.map((tab, index) => (
                <Tab key={index} value={tab.value} label={tab.label} />
              ))
            }
          </Tabs>
        </Box>
        {
          selectedTab === tabOptions[0].value && (
            <Box sx={{ padding: '16px 8px' }}>
              <Overview
                auth={auth}
                device={device}
                changeToConfigurable={changeToConfigurable}
                startAdoptProcessForOneDevice={startAdoptProcessForOneDevice}
              />
            </Box>
          )
        }
        {
          selectedTab === tabOptions[1]?.value && (
            <Box sx={{ padding: '16px 8px' }}>
              <IpSettings
                auth={auth}
                device={device}
                onToggleSlider={onToggleSlider}
                isNotSupportDNSDevice={isNotSupportDNSDevice}
              />
            </Box>
          )
        }
      </div>
    </>
  );
}

export default Slider;